<template>
  <div class="filter-wrapper">
    <div class="filter-icon" @click="toggleDropdown">
      <i class="ri-equalizer-line"></i>
    </div>

    <div v-if="isOpen" class="dropdown-card">
      <h6 class="fw-bold">FILTER OPTIONS</h6>

      <hr class="text-muted" style="border-top: 1px dashed #6c757d" />

      <div class="row mt-4">
        <div
          class="col-6 col-md-3 mb-3"
          v-for="(option, index) in filterOptions"
          :key="index"
        >
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="filterOptions"
              :id="'filter-' + index"
              :value="option.value"
              v-model="selectedOption"
              @change="emitSelection(option)"
            />
            <label class="form-check-label" :for="'filter-' + index">
              {{ option.label }}
            </label>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end gap-2">
        <span @click="closeDropdown" class="text-danger fw-bold" style="cursor: pointer;">CLOSE</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterOptions",
  props: {
    filterOptions: {
      type: Array,
      required: true,
    },
    initialSelected: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isOpen: false,
      selectedOption:this.initialSelected
    };
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    closeDropdown() {
      this.isOpen = false;
    },
    emitSelection(options) {
      this.$emit("apply", options);
    },
  },
};
</script>

<style scoped>
.filter-wrapper {
  position: relative;
  width: 65px;
  border-radius: 6px;
}

.filter-icon {
  background-color: #f3f3f9;
  font-size: 25px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dropdown-card {
  position: absolute;
  top: 45px;
  width: 600px;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  z-index: 10;
  padding: 16px;
}
</style>
